import WalletSigningController from "../lib/wallet_signing_controller"
import { COPY } from "../lib/wallet_connector_controller"
import { setBusy } from "../lib/work_status"

// The stages a signature goes through, as the step line names them: the
// server builds it, the wallet signs it, the server sends and records it.
export const STEPS = [ "Getting ready", "Your wallet", "Recording it" ]

// Used by both the plan-approval page and the stop-my-plan signing on the
// subscription page — the build and confirm URLs come from the markup.
export default class extends WalletSigningController {
  static values = {
    buildUrl: String,
    confirmUrl: String,
    // A selector for a form whose fields the build needs (the send page);
    // the approval and stop pages have nothing to add.
    form: String
  }

  buildPayload() {
    if (!this.formValue) return {}
    const form = document.querySelector(this.formValue)
    return form ? Object.fromEntries(new FormData(form)) : {}
  }

  get idleStatus() {
    return this.privyProvider ? "Ready when you are" : "Connect your wallet to continue"
  }

  // Build fresh, let the wallet sign it, then hand it back for the server to send.
  // A rejection leaves the server's records exactly as they were, so the same
  // button just works again.
  async sign(event) {
    const button = event.currentTarget
    setBusy(button, true)
    let step = 0

    try {
      // Connect on the way if no wallet is attached yet — one tap does both.
      if (!(await this.ensureConnected())) {
        setBusy(button, false)
        return
      }

      this.status("Setting this up…", "working", { steps: STEPS, step })
      const { transaction, redirect_to: alreadyDone } = await this.postJSON(this.buildUrlValue, this.buildPayload())

      // The server can discover mid-build that there is nothing left to sign —
      // a stop whose earlier signature already landed. Done is done: go there.
      if (alreadyDone) {
        this.status("Done", "done", { steps: STEPS, step })
        window.location.assign(alreadyDone)
        return
      }

      step = 1
      this.status(this.walletPromptCopy, this.walletPromptState, { steps: STEPS, step })
      const signed = await this.signForServer(transaction)

      // The executor pays and sends (2026-10-17): the signed transaction goes
      // back, and the server answers once the chain has confirmed it.
      step = 2
      this.status("Confirming…", "working", { steps: STEPS, step })
      const { redirect_to } = await this.postJSON(this.confirmUrlValue, { transaction: signed })

      this.status("Done", "done", { steps: STEPS, step })
      window.location.assign(redirect_to || window.location.pathname)
    } catch (error) {
      this.log("signing failed", error)
      this.status(error.userMessage || COPY.rejected, "error", { steps: STEPS, step })
      setBusy(button, false)
    }
  }
}
